require("./tunnel.scss")

require("../../images/tunnel/paul.jpg");
require("../../images/tunnel/sabrina.jpg");

const chatQuestion = require("./chat_box_question.html")
const chatAnswer = require("./chat_box_answer.html")
const sliderAnswer = require("./question_budget_slider.html")
const whichBidgetAnswer = require("./question_budget_type_radio.html")
const whichBidgetModalAnswer = require("./question_budget_type_modal.html")

const ownerAnswer = require("./question_owner_radio.html")
const searchDeadlineAnswer = require("./question_delay_radio.html")
const surfaceAnswer = require("./question_surface_radio.html")
const prestationAnswer = require("./question_prestation_radio.html")
const contactAnswer = require("./question_contact_radio.html")
const searchAnswer = require("./question_search_radio.html")
const maritalAnswer = require("./question_marital_radio.html")
const typologiesAnswer = require("./question_typologies_radio.html")
const validationAnswer = require("./question_final_validation.html")
const writingLeftQuestion = require("./chat_writing_left.html")
const questionJson = require('./questions.json')
const navLine = require('./nav-line.html')
const circleSelected = require('./circle_selected.html')
const circleNotSelected = require('./circle_not_selected.html')
const circleDone = require('./circle_done.html')


const TIME_FADE_IN = 0;

class TunnelBuilder {
  constructor(tunnelTarget, listTarget) {
    this.tunnelTarget = tunnelTarget;
    this.listTarget = listTarget;
    this.owner_kind = tunnelTarget.find("#prospect_owner_kind");
    this.marital_status = tunnelTarget.find("#prospect_marital_status");
    this.typologies = tunnelTarget.find(".prospect_typologies");

    this.search_kind = tunnelTarget.find("#prospect_search_kind");
    this.search_deadline = tunnelTarget.find("#prospect_search_deadline");
    this.search_area_min = tunnelTarget.find("#prospect_search_area_min");
    this.search_area_max = tunnelTarget.find("#prospect_search_area_max");
    this.search_benefits = tunnelTarget.find(".prospect_search_benefits");
    this.children = tunnelTarget.find("#prospect_prestation");
    this.contact = tunnelTarget.find("#prospect_contact_mean");

    this.search_budget = tunnelTarget.find("#prospect_search_budget");
    this.budgetFormatter = new Intl.NumberFormat('fr', {
      style: 'currency',
      currency: 'EUR'
    });

    this.stepNumber = 0;
  }


  // Order of questions
  // Search -> Kind -> Marital -> Budget
  setup() {
    this.tunnelTarget.height(10000);
    this.search_kind.off('change').on('change', () => {
      this.askQuestionAndCallBack(2, this.answerOwnerRadio, this, true);
    });

    this.owner_kind.off('change').on('change', () => {
      this.askQuestionAndCallBack(3, this.answerSearchDeadlineRadio, this, true);
    });

    this.search_deadline.off('change').on('change', () => {
      this.askQuestionAndCallBack(4, this.answerTypologiesRadio, this, true);
    });

    this.typologies.off('change').on('change', () => {
      this.askQuestionAndCallBack(5, this.answerSurfaceRadio, this, false);
    });

    this.search_area_max.off('change').on('change', () => {
      this.askQuestionAndCallBack(6, this.answerPrestationRadio, this, false);
    });
    this.search_benefits.off('change').on('change', () => {
      this.askQuestionAndCallBack(7, this.answerMaritalStatusRadio, this, true);
    });

    this.marital_status.off('change').on('change', () => {
      this.askQuestionAndCallBack(8, this.answerWhichBudget, this, true);
    });

    this.search_budget.off('change').on('change', () => {
      this.askQuestionAndCallBack(11, this.answerContactRadio, this, true);
    });

    this.contact.off('change').on('change', () => {
      this.askQuestionAndCallBack(12, this.answerFinalValidation, this, true);
    });

    this.askSearchQuestion();
  }

  // ------------ Search kind ----------------

  askQuestionAndCallBack(questionId, callback, _this, moveNavBar){
   if(moveNavBar)
     this.createNavBar();
    $.when(this.askQuestion(questionId)).then(() => {
      callback(_this);
    });
  }

  askSearchQuestion() {
    this.createNavBar();
    $.when(this.askQuestion(0)).then(() => {
      $.when(this.askQuestion(1)).then(() => {
        this.answerSearchRadio();
      });
    });
  }

  answerSearchRadio() {
    $.when(this.showDiv($(searchAnswer), 'RIGHT')).then(() => {
      $('.radioQuestion input').off('click').one('click', () => {
        var value = $('.radioQuestion input:radio:checked').val();
        this.search_kind.val(value);
        var text = $("label[for='" + $('.radioQuestion input:radio:checked').attr('id') + "']").html();

        $.when(this.hideDiv(".radioQuestion", this.sayResponse(text))).then(() => {
          this.search_kind.change();
        });
      });
    });
  }

  // ------------- Owner or Renter -------------

  answerOwnerRadio(_this) {
    $.when(_this.showDiv($(ownerAnswer), 'RIGHT')).then(() => {
      $('.radioQuestion input').off('click').one('click', () => {
        var value = $('.radioQuestion input:radio:checked').val();
        _this.owner_kind.val(value);
        var text = $("label[for='" + $('.radioQuestion input:radio:checked').attr('id') + "']").html();

        $.when(_this.hideDiv(".radioQuestion",_this.sayResponse(text))).then(() => {
          _this.owner_kind.change();
        });
      });
    });
  }

   // --------- Search Deadline --------
  answerSearchDeadlineRadio(_this) {
    $.when(_this.showDiv($(searchDeadlineAnswer), 'RIGHT')).then(() => {
      $('.radioQuestion input').off('click').one('click', () => {
        _this.search_deadline.val($('.radioQuestion input:radio:checked').val());
        var text = $("label[for='" + $('.radioQuestion input:radio:checked').attr('id') + "']").html();
        $.when(_this.hideDiv(".radioQuestion", _this.sayResponse(text))).then(() => {
          _this.search_deadline.change();
        });
      });
    });
  }

  // --------- Typologies Status --------
  answerTypologiesRadio(_this) {
    $.when(_this.showDiv($(typologiesAnswer), 'RIGHT')).then(() => {

      $('.radioQuestionTypo input').on('click', () => {
        if($('.radioQuestionTypo input:checkbox:checked').length > 0)
          $('#typologies-validator').prop('disabled', false);
        else
          $('#typologies-validator').prop('disabled', true);
      });

      $('#typologies-validator').off('click').one('click', () => {
        var text = [];
        $('.radioQuestionTypo input:checkbox:checked').each(function(index) {
          text.push($(this).attr('value') );
          $('#prospect_typologies_' +  $(this).attr('value').toLowerCase()).prop('checked', true)
        });

        $.when(_this.hideDiv(".radioQuestionTypo", _this.sayResponse(text.join(' | ')))).then(() => {
          _this.typologies.change();
        });
      })
    });
  }

   // --------- Surface --------
  answerSurfaceRadio(_this) {
    $.when(_this.showDiv($(surfaceAnswer), 'RIGHT')).then(() => {
      $('.radioQuestion input').off('click').one('click', () => {
        var selectedInput = $('.radioQuestion input:radio:checked');
        _this.search_area_min.val(selectedInput.data('area-min'));
        _this.search_area_max.val(selectedInput.data('area-max'));
        var text = $("label[for='" + $('.radioQuestion input:radio:checked').attr('id') + "']").html();
        $.when(_this.hideDiv(".radioQuestion", _this.sayResponse(text))).then(() => {
          _this.search_area_max.change();
        });
      });
    });
  }


   // --------- Prestation --------
  answerPrestationRadio(_this) {
    $.when(_this.showDiv($(prestationAnswer), 'RIGHT')).then(() => {

      $('#benefits-validator').off('click').one('click', () => {
        var text = [];
        $('.radioQuestionTypo input:checkbox:checked').each(function(index) {
          text.push($(this).data('text'));
          $('#prospect_search_benefits_' +  $(this).attr('value')).prop('checked', true)
        });

        if(text.length === 0)
          text.push('Pas de prestation spécifique');
        $.when(_this.hideDiv(".radioQuestionTypo", _this.sayResponse(text.join(' | ')))).then(() => {
          _this.search_benefits.change();
        });
      })
    });
  }

  // --------- Marital Status --------
  answerMaritalStatusRadio(_this) {
    $.when(_this.showDiv($(maritalAnswer), 'RIGHT')).then(() => {
      $('.radioQuestion input').off('click').one('click', () => {
        _this.marital_status.val($('.radioQuestion input:radio:checked').val());
        var text = $("label[for='" + $('.radioQuestion input:radio:checked').attr('id') + "']").html();
        $.when(_this.hideDiv(".radioQuestion", _this.sayResponse(text))).then(() => {
          _this.marital_status.change();
        });
      });
    });
  }

//-------------- Which Budget --------
  answerWhichBudget(_this) {
    _this.tunnelTarget.append($(whichBidgetModalAnswer));
    $.when(_this.showDiv($(whichBidgetAnswer), 'RIGHT')).then(() => {

      $('.radioQuestion input').off('click').one('click', () => {
        if($('.radioQuestion input:radio:checked').val() === 'yes') {
          var text = $("label[for='" + $('.radioQuestion input:radio:checked').attr('id') + "']").html();

          $.when(_this.hideDiv(".radioQuestion", _this.sayResponse(text))).then(() => {
            _this.askQuestionAndCallBack(9, _this.answerBudgetSlider, _this, false);
          });
        } else {
          var text = $("label[for='" + $('.radioQuestion input:radio:checked').attr('id') + "']").html();

          $.when(_this.hideDiv(".radioQuestion", _this.sayResponse(text))).then(() => {
            $('#income').off('input').on('input', () => {
              if($('#income').val() === '0' || $('#income').val() === '')
                $('#budgetValidate').prop('disabled', true);
              else
                $('#budgetValidate').prop('disabled', false);
              _this.calculateLoanCapacity();
            });

            $('#apport').off('input').on('input', () => {
              _this.calculateLoanCapacity();
            });

            $('#duration').off('change').on('change', () => {
              _this.calculateLoanCapacity();
            });

            $('#budgetValidate').off('click').one('click', () => {
              const value = $('#loanCapacity').data('budget');
              _this.search_budget.val(value);
              const formattedValue = `${Number(value).toLocaleString('fr')} €`;
              $.when(_this.showDiv(_this.sayResponse(formattedValue), 'RIGHT')).then(() => {
              $('#budgetModal').modal('hide');
              _this.search_budget.change();
              });
            })
          });
        }
      });
    });
  }

  //------------- Budget -------------------
  answerBudgetSlider(_this) {
    $.when(_this.showDiv($(sliderAnswer), 'RIGHT')).then(() => {

      $("#budget-slider").off('input').on('input', () => {
        $("#budget-slider-output").html(Number($("#budget-slider").val()).toLocaleString('fr'));
      });

      $('#budget-validator').off('click').one('click', () => {
        const value = $('#budget-slider').val();
        _this.search_budget.val(value);
        const formattedValue = `${Number(value).toLocaleString('fr')} €`;
        $.when(_this.hideDiv("#budget", _this.sayResponse(formattedValue))).then(() => {
          _this.search_budget.change();
        });
      });
    });
  }

  // --------- Which Contact Status --------
  answerContactRadio(_this) {
    $.when(_this.showDiv($(contactAnswer), 'RIGHT')).then(() => {

      $('.radioQuestion input').off('click').one('click', () => {
        var value = $('.radioQuestion input:radio:checked').val();
        _this.contact.val(value);
        var text = $("label[for='" + $('.radioQuestion input:radio:checked').attr('id') + "']").html();

        $.when(_this.hideDiv(".radioQuestion", _this.sayResponse(text))).then(() => {
          _this.contact.change();
        });
      });
    });
  }

  //------------ Final validate ----------------
  answerFinalValidation(_this) {
    $.when(_this.showDiv($(validationAnswer), 'RIGHT')).then(() => {
      _this.tunnelTarget.scrollTop(10000);

      $('#validation-button').off('click').one('click', () => {
        $("#form-hidden").find('.edit_prospect').trigger('submit');
      });
    });
  }

  //---------- NAV BAR ---------
  createNavBar(){
    var _this = this;
    var i = 0;
    _this.listTarget.empty();
    questionJson['data'].forEach((e) => {
      if(e.showed === true) {
        var element = $(navLine);
        element.find('.description').html(e.desc);
        var circle

        if(this.stepNumber == i) {
          circle = $(circleSelected);
          circle.find('.circle-number').html(i + 1);
        } else if (i < this.stepNumber) {
          circle = $(circleDone)
        } else {
          circle = $(circleNotSelected);
          circle.find('.circle-number').html(i + 1);
        }
        element.find('.tunnel-line').prepend(circle);
        _this.listTarget.append(element);
        i++;
      }
    });
    this.stepNumber++;
  }

  // HELPER METHOD
  calculateLoanCapacity() {
    var monthly = $('#income').val();
    var rate = $('#duration option:selected').data('rate');
    var year = $('#duration option:selected').data('duration');
    var apport = $('#apport').val();

    var taegMonth = rate / 12;
    var duration = year * 12;
    var end = (monthly*(1-Math.pow((1+taegMonth),-duration)))/(taegMonth)
    if(!apport.trim()) {
      apport = 0;
    }
    var finalValue = Math.round(end) + parseInt(apport);

    $('#loanCapacity').html(Number(finalValue).toLocaleString('fr'));
    $('#loanCapacity').data('budget', finalValue);
  }

  askQuestion(index) {
    var question = $(chatQuestion);
    question.find(".content-question").html(questionJson['data'][index]['question']);
    return this.showDiv(question, "LEFT");
  }

  sayResponse(text) {
    var question = $(chatAnswer);
    question.find(".content-question").html(text);
    return question;
  }

  hideDiv(className, response) {
    var divToValidate = $(className);
    divToValidate.parent().replaceWith(response);
    return this.tunnelTarget.scrollTop(this.tunnelTarget.height());
  }

  showDiv(div, side) {
    if (side === 'LEFT') {
      var writing = $(writingLeftQuestion);
      this.tunnelTarget.append(writing);
      this.tunnelTarget.scrollTop(10000);
      return $.when(writing.delay(900)).then(() => {
        return $.when(writing.replaceWith(div)).then( () => {
          return this.tunnelTarget.scrollTop(10000);
        })
      });
    } else {
      return $.when(div.delay(300)).then(() => {
        this.tunnelTarget.append(div);
        return $.when(div.fadeIn(TIME_FADE_IN)).then(() => {
          return this.tunnelTarget.scrollTop(10000);
        });
      });
    }
  }
}

var buildTunnel = function (listTarget) {
  var builder = new TunnelBuilder($(this), listTarget);
  builder.setup();

  return builder;
};

export default buildTunnel;
